import { render } from "./AdminHomeBlock.vue?vue&type=template&id=4fe980ce"
import script from "./AdminHomeBlock.vue?vue&type=script&lang=js"
export * from "./AdminHomeBlock.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__